{
  "ingredientUnit": {
    "bag": {
      "empty": "袋",
      "plural": "袋",
      "singular": "袋"
    },
    "branch": {
      "empty": "枝",
      "plural": "枝",
      "singular": "枝"
    },
    "bunch": {
      "empty": "束",
      "plural": "束",
      "singular": "束"
    },
    "can": {
      "empty": "罐",
      "plural": "罐",
      "singular": "罐"
    },
    "centiliter": {
      "empty": "厘升",
      "plural": "厘升",
      "singular": "厘升"
    },
    "clove": {
      "empty": "瓣",
      "plural": "瓣",
      "singular": "瓣"
    },
    "cup": {
      "empty": "杯",
      "plural": "杯",
      "singular": "杯"
    },
    "dash": {
      "empty": "少許",
      "plural": "少許",
      "singular": "少許"
    },
    "decigram": {
      "empty": "分克",
      "plural": "分克",
      "singular": "分克"
    },
    "deciliter": {
      "empty": "分升",
      "plural": "分升",
      "singular": "分升"
    },
    "drop": {
      "empty": "滴",
      "plural": "滴",
      "singular": "滴"
    },
    "fluidOunce": {
      "empty": "液量盎司",
      "plural": "液量盎司",
      "singular": "液量盎司"
    },
    "gram": {
      "empty": "公克",
      "plural": "公克",
      "singular": "公克"
    },
    "kilogram": {
      "empty": "公斤",
      "plural": "公斤",
      "singular": "公斤"
    },
    "liter": {
      "empty": "公升",
      "plural": "公升",
      "singular": "公升"
    },
    "microgram": {
      "empty": "微克",
      "plural": "微克",
      "singular": "微克"
    },
    "milligram": {
      "empty": "毫克",
      "plural": "毫克",
      "singular": "毫克"
    },
    "milliliter": {
      "empty": "毫升",
      "plural": "毫升",
      "singular": "毫升"
    },
    "ounce": {
      "empty": "盎司",
      "plural": "盎司",
      "singular": "盎司"
    },
    "package": {
      "plural": "包",
      "singular": "包"
    },
    "piece": {
      "empty": "塊",
      "plural": "塊",
      "singular": "塊"
    },
    "pinch": {
      "empty": "些許",
      "plural": "些許",
      "singular": "些許"
    },
    "pound": {
      "empty": "磅",
      "plural": "磅",
      "singular": "磅"
    },
    "sachet": {
      "empty": "小包",
      "plural": "小包",
      "singular": "小包"
    },
    "shot": {
      "empty": "一小杯",
      "plural": "一小杯",
      "singular": "一小杯"
    },
    "slice": {
      "empty": "片",
      "plural": "片",
      "singular": "片"
    },
    "stick": {
      "empty": "條",
      "plural": "條",
      "singular": "條"
    },
    "tablespoon": {
      "empty": "湯匙",
      "plural": "湯匙",
      "singular": "湯匙"
    },
    "teaspoon": {
      "empty": "茶匙",
      "plural": "茶匙",
      "singular": "茶匙"
    }
  }
}